<main class="circle-gradient-1">
  <section class="breadcrumb-sec event-sec">
      <div class="container">
          <div class="row g-0">
              <div class="col-lg-6 col-md-6">
                  <ul class="breadcrumb">
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="fa fa-angle-right"></i></li>
                      <li><a href="events">Events</a></li>
                      <li><i class="fa fa-angle-right"></i></li>
                      <li><a routerLink="/events" fragment="technical">Technical</a></li>
                      <li><i class="fa fa-angle-right"></i></li>
                      <li>Science Day</li>
                  </ul>
                  <div class="sec-title">
                      <h1><span>Science Day</span></h1>
                      <p>GHRCACS,Pune organised a National Science Day 2025 at seminar hall.
                      </p>

                  </div>
              </div>
          </div>
          <div class="breadcrumb-overlay overflow-hidden"
              style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/science-day-4.avif);">
          </div>
      </div>
  </section>
  <section class="section-lg">
    <div class="container">
      <div class="sec-title text-center">
          <h2><span>Photo Gallery</span></h2>
      </div>
      <div class="demo-gallery">
        <ul  appLightgallery>
            <li class="grid-item1"
                data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/science-day-1.avif"
                data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/science-day-1.avif">
                <a href="#">
                    <img class="img-fluid"
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/science-day-1.avif">
                </a>
            </li>
            <li class="grid-item2"
                data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/science-day-2.avif"
                data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/science-day-2.avif">
                <a href="#">
                    <img class="img-fluid"
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/science-day-2.avif">
                </a>
            </li>
            <li class="grid-item3 d-none d-lg-block d-md-block"
                data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/science-day-3.avif"
                data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/science-day-3.avif">
                <a href="#">
                    <img class="img-fluid"
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/science-day-3.avif">
                </a>
            </li>
        </ul>
        </div>
    </div>
  </section>
</main>
